<template>
  <div
    class="c-step-container"
    :class="{ isOpen, isProductSelected: !!selectedSku }"
  >
    <div class="c-step-container__head">
      <span
        class="c-step-container__check"
        :class="{ isProductSelected: !!selectedSku }"
      ></span>
      <span>ステップ{{ stepNumber }}</span>
      <h2 class="c-step-container__step-title">{{ step.title }}</h2>
      <div
        class="c-step-container__check"
        :class="{ isProductSelected: !!selectedSku }"
      ></div>
    </div>

    <div
      class="c-step-container__selected-product"
      v-if="selectedProduct && !isOpen"
    >
      <img
        class="c-step-container__selected-product-image"
        :src="selectedProduct.image"
        :alt="selectedProduct.name"
      />
    </div>

    <ul class="c-step-container__products" v-show="isOpen">
      <li
        v-for="product in step.products"
        :key="product.sku"
        class="c-step-container__product"
      >
        <img
          class="c-step-container__product-image"
          :class="{ isSelected: isSelected(product) }"
          :src="product.image"
          :alt="product.name"
          @click.stop="$emit('product-clicked', product)"
        />
        <a
          class="c-step-container__product-link"
          :href="`/products/${product.sku}`"
          target="_blank"
          rel="noopener noreferrer"
          >詳細を見る</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ComponentStepContainer',
  props: {
    isOpen: { type: Boolean, default: false },
    selectedSku: { type: String, default: '' },
    step: { type: Object, required: true },
    stepNumber: { type: Number, required: true },
  },
  data() {
    return {}
  },
  computed: {
    selectedProduct() {
      return this.step.products.find(
        (product) => product.sku === this.selectedSku
      )
    },
  },
  methods: {
    isSelected(product) {
      return this.selectedSku === product.sku
    },
  },
}
</script>

<style scoped lang="scss">
@use '~/scss/generic/variables';

.c-step-container {
  border-radius: 8px;
  border: 1px solid variables.$color-accent-weak;
  cursor: pointer;
  padding: 10px;
  transition: background-color 0.3s;

  &:hover {
    background-color: rgba(variables.$color-accent-weak, 0.3);
  }

  &.isOpen,
  &.isProductSelected {
    background-color: variables.$color-accent-weak;
  }

  &__head {
    padding: 10px 0;
    position: relative;
    text-align: center;
  }

  &__check {
    background-color: #fff;
    border: 1px solid variables.$color-accent-weak;
    border-radius: 12px;
    bottom: 0;
    display: block;
    height: 24px;
    left: 10px;
    margin: auto;
    position: absolute;
    top: 0;
    width: 24px;

    &.isProductSelected {
      background-color: variables.$color-accent;

      &::before {
        content: '';
        border-left: 2px solid #fff;
        border-bottom: 2px solid #fff;
        bottom: 2px;
        height: 7px;
        left: 0;
        margin: auto;
        position: absolute;
        right: 0;
        top: 0;
        transform: rotate(-45deg);
        width: 10px;
      }
    }
  }

  &__step-title {
    font-size: 16px;
    font-weight: normal;
    margin-top: 5px;
  }

  &__products {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 20px 0;
  }

  &__product {
    margin: 10px 5px;
    text-align: center;
    width: 100px;
  }

  &__selected-product {
    padding: 20px 0;
    text-align: center;
  }

  &__product-image,
  &__selected-product-image {
    border-radius: 8px;
    height: 100px;
    width: 100px;
  }

  &__product-image {
    cursor: pointer;
    transition: opacity 0.3s;

    &:hover {
      opacity: 0.6;
    }

    &.isSelected {
      border: 1px solid variables.$color-accent;
    }
  }

  &__product-link {
    color: variables.$color-accent;
    display: block;
    font-size: 12px;
    margin-top: 5px;
    text-decoration: none;
    transition: opacity 0.3s;
    position: relative;

    &:hover {
      opacity: 0.6;
    }

    &::after {
      content: '';
      width: 6px;
      display: inline-block;
      height: 6px;
      margin-left: 5px;
      border-right: 2px solid variables.$color-accent;
      border-top: 2px solid variables.$color-accent;
      transform: rotate(45deg);
    }
  }
}
</style>
